import { render, staticRenderFns } from "./SecondaryPinnedNavItem.vue?vue&type=template&id=4e70988c"
import script from "./SecondaryPinnedNavItem.vue?vue&type=script&lang=js"
export * from "./SecondaryPinnedNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports